import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { logoutUser } from "helpers/user-session";
import { ImaginePlusAssessment } from "../growbot/icons";
import useUser from "../../hooks/useuser";
import "./assessment-header.scss";

function AssessmentHeader() {
  const { user } = useUser();
  const logout = () => {
    logoutUser(user);
  };
  return (
    <Navbar className="iplusaheader pe-3">
      <Nav className="me-auto">
        <div className="brand">
          <ImaginePlusAssessment />
        </div>
        <h1>My Assessments</h1>
      </Nav>
      {user && (
        <Nav>
          <NavDropdown title={`${user.fullname}`} id="collapsible-nav-dropdown" align="end">
            <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      )}
    </Navbar>
  );
}

export default AssessmentHeader;
